module.exports = __webpack_public_path__ + "static/media/loggedin.49f2c540.png";